import api from "./api";

export interface MenuItem {
  addons?: Array<{ name: string; price: number }>;
  availability?: string;
  category: string;
  description: string;
  featured?: boolean;
  id?: string;
  images: string[];
  isAvailable?: boolean;
  name: string;
  popular?: boolean;
  price: number;
  promoPrice?: number;
  sku?: string;
  slug?: string;
  variants?: Array<{ name: string; price: number; stock: number }>;
}

// Order Management
export interface Order {
  // Add other order fields as needed
  [key: string]: any;
  id?: string;
}

// Menu Category Management
class MenuCategoryService {
  async addCategory(data: { description?: string; name: string }) {
    return api.post("/menu-categories", data);
  }
  async deleteCategory(id: string) {
    return api.delete(`/menu-categories/${id}`);
  }
  async getCategories(params?: any) {
    return api.get("/menu-categories", { params });
  }
  async getCategory(id: string) {
    return api.get(`/menu-categories/${id}`);
  }
  async updateCategory(
    id: string,
    data: { description?: string; name?: string },
  ) {
    return api.put(`/menu-categories/${id}`, data);
  }
}

class MenuService {
  async addMenuItem(data: FormData | MenuItem) {
    if (data instanceof FormData) {
      // Let browser set Content-Type with boundary
      return api.post("/menu-items", data);
    }
    return api.post("/menu-items", data);
  }
  async deleteMenuItem(id: string) {
    return api.delete(`/menu-items/${id}`);
  }
  async getMenuItems(params?: any) {
    return api.get("/menu-items", { params });
  }

  /**
   * Get menu items uploaded by a specific user (by user id)
   */
  async getMenuItemsByUser(userId: string) {
    return this.getMenuItems({ uploaded_by: userId });
  }

  async updateAvailability(id: string, available: boolean) {
    // PATCH to /menu-items/{id}/availability with { available: 1 | 0 }
    return api.patch(`/menu-items/${id}/availability`, {
      available: available ? 1 : 0,
    });
  }

  async updateImage(id: string, imageFile: File) {
    console.log("MenuService.updateImage - id:", id);
    const fd = new FormData();
    fd.append("image", imageFile);
    // Log FormData contents for debugging
    for (const pair of fd.entries()) {
      console.log("FormData:", pair[0], pair[1]);
    }
    return api.post(`/menu-items/${id}/image`, fd);
  }

  async updateMenuItem(id: string, data: Partial<MenuItem>) {
    return api.put(`/menu-items/${id}`, data);
  }
}

class OrderService {
  async addOrder(data: Order) {
    return api.post("/orders", data);
  }
  async deleteOrder(id: string) {
    return api.delete(`/orders/${id}`);
  }
  async getOrder(id: string) {
    return api.get(`/orders/${id}`);
  }
  async getOrders(params?: any) {
    return api.get("/orders", { params });
  }
  async updateOrder(id: string, data: Partial<Order>) {
    return api.put(`/orders/${id}`, data);
  }
}

export default new MenuService();
export const menuCategoryService = new MenuCategoryService();
export const orderService = new OrderService();
export const menuService = new MenuService();
